/**
 * Imports
*/

// utils
import lang from '../../misc/i18n.js';
import InstabergUtils from '../../misc/utils.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergViewSmallList_ListItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isHovered: false
    };
  }

  render()
  {
    let { isHovered } = this.state;
    let isHoveredCss = isHovered ? `${alias}hover-state` : '';

    const { video } = this.props;
    let { image, total_comments, total_likes, caption, link, post_type } = video;

    const styleGridImg = {
      backgroundImage: `url(${image})`,
    };

    total_likes = 'undefined' === typeof total_likes ? 0 : total_likes;
    total_likes = InstabergUtils.humanFormat( total_likes );

    total_comments = 'undefined' === typeof total_comments ? 0 : total_comments;
    total_comments = InstabergUtils.humanFormat( total_comments );

    return (
      <div
        className={ `${alias}element` }
        data-key={ video.id }
        onMouseEnter={ (e) => { this.handleMenuHover( e ) } }
        onMouseLeave={ (e) => { this.handleMenuHover( e ) } }
        onClick={ (e) => { this.handleMenuClick( e, { videoid: video.id, image, post_type } ) } }
      >

        <a href={ link } className={ `${alias}list5-img-url` }>
          <span className={ `${alias}img` }>
            { '' !== image ? <img src={ image } /> : '' }
            { InstabergUtils.itemShowIcon( post_type ) }
          </span>
        </a>

        <div
          style={ isHovered ? { background: this.props.pcstyle.background } : {} }
          className={ `${alias}overlay ${isHoveredCss}` }
        >

          <div className={ `${alias}list5-description` }>
            <div className={ `${alias}list5-misc` }>

              <span className={ `${alias}misc-likes` }>
                <a href={ link } target="_blank" style={{ fontFamily: this.props.pcstyle.fontFamily }}><i className="mi-icon mi-icon-heart5"></i>{ total_likes }</a>
              </span>
              <span className={ `${alias}misc-comments` }>
                <a href={ link } target="_blank" style={{ fontFamily: this.props.pcstyle.fontFamily }}><i className="mi-icon mi-icon-bubbles2"></i>{ total_comments }</a>
              </span>

            </div>
          </div>

        </div>

      </div>
    );
  }

  handleMenuHover( event )
  {
    this.setState({
      isHovered: ! this.state.isHovered
    });
  }

  handleMenuClick( event, pms )
  {
    event.preventDefault();
    this.props.onClickListItem( pms );
  }
}

class InstabergViewSmallList extends Component {

  constructor(props) {
    super(props);
  }

  render() 
  {
    return ( this.PrintVideosList() );
  }

  PrintVideoSingleElement( video )
  {
    let pcstyle = {
      background: this._get_option('primaryColor')['main_color'],
      fontFamily: this._get_option('primaryColor')['font_family']
    };

    return (
      <InstabergViewSmallList_ListItem
        pcstyle={ pcstyle }
        video={ video }
        onClickListItem={ (pms) => { this.props.onClickListItem( pms ) } }
      />
    );
  }

  PrintVideosList()
  {
    const { layoutType } = this.props.options;
    let { videos } = this.props;
    const smlGridCols = parseInt( this._get_option('smlGridCols') );

    if ( ! videos.length ) {
      return '';
    }

    const video_list = videos.map( video => {
      return ( this.PrintVideoSingleElement( video ) );
    });

    return (
      <React.Fragment>
        <div
          className={ `${alias}list5-grid ${alias}selector ${alias}list5-${smlGridCols}col` }
        >
          { video_list }
        </div>
      </React.Fragment>
    );
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

}
export { InstabergViewSmallList };


// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/templates/listsmall/tpl.view.js